export const tipoDenominacion = {
    Moneda: 1,
    Billete: 2,
    Tarjeta: 3
}